import { apiEndpoints, ApplicationSettings, CommandResult } from '../amorg-common';
import { commandAuthWrapper, queryAuthWrapper } from './serverApiHelpers';

export const applicationSettingsClientApi = {

    getApplicationSettings: async (): Promise<ApplicationSettings> =>
    {
        const data = await queryAuthWrapper(apiEndpoints.applicationSettings) as ApplicationSettings;
        data.employeePortalSettings.resetTimeStamp = new Date(data.employeePortalSettings.resetTimeStamp);
        return data;
    },

    updateApplicationSettings: async (settings: ApplicationSettings): Promise<CommandResult> =>
    {
        return await commandAuthWrapper(apiEndpoints.applicationSettings, 'PUT', {settings})
    }
};